import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, description, action }: SectionHeadingProps) {
  return (
    <div className="mb-7 flex flex-col gap-4 md:mb-9 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-flashlight-fill"></i>
            </span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-[32px]">
          {title}
        </h2>
        {description && (
          <p className="mt-2.5 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
            {description}
          </p>
        )}
      </div>
      {action}
    </div>
  );
}